// @flow

import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.freeDammLimon',
  title: 'hardCoded.title.freeDammLimon',
  slug: titleToSlug('hardCoded.title.freeDammLimon'),
  catalog: {
    title: 'hardCoded.catalog.title.freeDammLimon',
    catalogMedia,
    price: numberToCurrency('2.75'),
    color: '#fde020'
  }
}
